<template>
  <RevCard class="p-32">
    <RevContentBlock
      :button-label="i18n(translations.cta)"
      class="mb-6"
      has-rounded-container
      has-rounded-image
      :image-props
      target="_blank"
      :title="i18n(translations.title)"
      title-tag="h2"
      title-variant="title2"
      :to="proUrl"
      @click="handleClick"
    >
      <template #default>
        {{ i18n(translations.subtitle) }}
      </template>
    </RevContentBlock>
  </RevCard>
</template>

<script setup lang="ts">
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { useMarketplace } from '@backmarket/nuxt-module-marketplace/useMarketplace'
import { useTracking } from '@backmarket/nuxt-module-tracking/useTracking'
import { RevCard } from '@ds/components/Card'
import { RevContentBlock } from '@ds/components/ContentBlock'

import translations from './BmProContentBlock.translations'

const props = defineProps<{
  utmSource: string
  zone: string
  name: string
}>()

const i18n = useI18n()
const { trackClick } = useTracking()
const { market } = useMarketplace()

const UTM_MEDIUM = 'website'
const UTM_CAMPAIGN = `LIF_B2B_ALL_${market.countryCode}_INAP_BM4BConvergenceRedirection`
const UTM_CONTENT = 'dashboard'

const proUrl = `https://pro${market.domain}/?utm_source=${props.utmSource}&utm_medium=${UTM_MEDIUM}&utm_campaign=${UTM_CAMPAIGN}&utm_content=${UTM_CONTENT}`

const imageProps = {
  alt: i18n(translations.imageAlt),
  height: 222,
  width: 448,
  src: '/img/bmPro/man-shopping-bm-pro-website.png',
}

function handleClick() {
  trackClick({ zone: props.zone, name: props.name })
}
</script>
